import { memo } from 'react'
import { Document } from 'almanac-ui/icons'

type DefaultDocEmojiProps = {
  className?: string
}

export const DefaultDocEmoji = memo(({ className }: DefaultDocEmojiProps) => {
  return <Document className={className} />
})
